import { useEffect, useState } from "react";

import { useRouter } from "next/router";

import { CheckEmailScreen } from "components/shared/onboarding/CheckEmailScreen";

import { useAuth } from "contexts/authContext";

import { UserInfo, findUserByHandle } from "apis/user";

import { getUserFirstName } from "utils/accountProfile";
import { addToLocalStorage } from "utils/localStorage";
import { getOnboardingUrl } from "utils/urls";

import { SignUpForm } from "./SignUpForm";

type Props = {
  referrerHandle?: string;
  title?: string;
  subtitle?: string;
  redirectTo?: string;
  email?: string;
};
export const SignUpFlow = ({
  referrerHandle,
  title,
  subtitle,
  redirectTo,
  email,
}: Props) => {
  const [emailForResend, setEmailForResend] = useState("");
  const [referringUser, setReferringUser] =
    useState<Pick<UserInfo, "id" | "firstName">>();
  const { user } = useAuth();
  const router = useRouter();

  useEffect(() => {
    const get = async () => {
      if (referrerHandle) {
        const referringUserData = await findUserByHandle(referrerHandle);
        setReferringUser(referringUserData);
        if (referringUserData?.id)
          addToLocalStorage("referrerUserId", referringUserData.id);
      }

      if (user?.id)
        router.push(getOnboardingUrl({ currentPath: router.asPath }));
    };
    get();
  }, [referrerHandle, user?.id, router]);

  // Note that when trying to sign up with an existing email address,
  // it will check if the password is also the existing password and return a success if so.
  // however it will not sign the user in.
  // so in that case, we should probably not show the screen Check your email for a link
  // when trying to sign up with an existing email address and a wrong password it will respond with an error.(good)

  return (
    <div>
      {emailForResend ? (
        <CheckEmailScreen
          email={emailForResend}
          resetEmail={() => {
            setEmailForResend("");
          }}
        />
      ) : (
        <SignUpForm
          setEmailForResend={setEmailForResend}
          title={
            title ||
            (referringUser &&
              `${getUserFirstName(referringUser)} invited you to join Ribbon!`)
          }
          subtitle={
            subtitle ||
            (referringUser && "Landing your dream job is better with friends.")
          }
          redirectTo={redirectTo}
          email={email}
        />
      )}
    </div>
  );
};
